import * as styles from "./styles.module.scss"
import cx from "classnames"
import Link from "gatsby-link"
import React, { useContext } from "react"
import useScrollDirection, { Direction } from "../../hooks/use-scroll-direction"
// import { NavContext } from "components/Document"

const SubNavbarAbout: React.FC = () => {
  // const { scrolled } = useContext(NavContext)
  const scrolled = true
  const scrollDirection = useScrollDirection({
    initialDirection: Direction.Up,
  })
  return (
    <div
      className={cx({
        [styles.subNavbar]: true,
        [styles.isScrolled]: scrolled,
        [styles.isRolledUp]: scrollDirection === Direction.Down,
      })}
    >
      <div className={styles.padding}>
        <div className={styles.links}>
          <ul className={styles.linksList}>
            <li className={styles.linkWrap}>
              <Link
                className={styles.link}
                to="/about-us"
                id="LinkTo-aboutUs-ourMission"
              >
                <span className={styles.underline}>Our mission</span>
              </Link>
            </li>
            <li className={styles.linkWrap}>
              <Link
                className={styles.link}
                to="/about-us/company"
                id="LinkTo-aboutUs-company"
              >
                <span className={styles.underline}>Company</span>
              </Link>
            </li>
            <li className={styles.linkWrap}>
              <Link
                className={styles.link}
                to="/about-us/reviews"
                id="LinkTo-aboutUs-reviews"
              >
                <span className={styles.underline}>Reviews</span>
              </Link>
            </li>
            <li className={styles.linkWrap}>
              <Link
                className={styles.link}
                to="/about-us/media"
                id="LinkTo-aboutUs-media"
                data-qa="see-all-media"
              >
                <span className={styles.underline}>Media</span>
              </Link>
            </li>
            <li className={styles.linkWrap}>
              <Link
                className={styles.link}
                to="/about-us/careers"
                id="LinkTo-aboutUs-careers"
              >
                <span className={styles.underline}>Careers</span>
              </Link>
            </li>
            <li className={styles.linkWrap}>
              <Link
                className={styles.link}
                to="/about-us/contact-us"
                id="LinkTo-aboutUs-contactUs"
              >
                <span className={styles.underline}>Contact us</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default SubNavbarAbout
